import { ACTION_LOGOUT_INITIATED, ADD_SESSION, RESET_STATE, UPDATE_ERROR, UPDATE_MESSAGE } from './types';
import * as HttpMethod from '../commons/backend/httpMethodConstants';
import { API_KEY, LABS_API_HOST, PROCUREMENT_API_HOST } from './../commons/backend/api-config';
import * as ApiEndpoint from './../commons/backend/apiEndpoints';
import { checkLabSeller } from '../commons/utils';
import { setBaseUrl } from '../commons/backend/dentalCorpBackendProxy';

function _fetch(baseURL, httpMethod, endpoint, data, session, timeoutInMillis) {
	let sessiontoken = null;
	if (session) {
		sessiontoken = session.sessiontoken;
	}
	let opts = {
		method: httpMethod,
		mode: 'cors',
		cache: 'no-store',
		//credentials: 'include'
	};
	if (httpMethod) opts.method = httpMethod;
	opts.url = baseURL + endpoint;
	opts.headers = {};
	opts.headers['Content-Type'] = 'application/json';
	opts.headers['x-dentalcorp-api-key'] = API_KEY;

	if (sessiontoken) opts.headers['x-dentalcorp-sessiontoken'] = sessiontoken;

	if (data) {
		opts.body = JSON.stringify(data);
	}
	return fetch(opts.url, opts, timeoutInMillis)
		.then((resp) => {
			return resp.json();
		})
		.then((body) => {
			if (!body.ok) {
				let err = new Error(body.error.reason);
				err.code = body.error.code;
				return Promise.reject(err);
			}
			return Promise.resolve(body);
		})
		.catch((err) => {
			return Promise.reject(err);
		});
}

export const wait = (ms) => {
	return new Promise((resolve) => setTimeout(resolve, ms));
};

export const reloadPage = async () => {
	await wait(500);
	window.location.reload();
};

export const purgeState = () => ({
	type: ACTION_LOGOUT_INITIATED,
	payload: false,
});

async function redeemSessionAPI(sessiontoken) {
	let { response: resp } = await _fetch(HttpMethod.POST, ApiEndpoint.REDEEM_SESSION_URL, { sessiontoken });
	if (resp) {
		return resp;
	}
}

export const redeemSession = (sessiontoken) => {
	return async (dispatch, getState) => {
		try {
			let user = await redeemSessionAPI(sessiontoken);
			dispatch({ type: ADD_SESSION, payload: user });
			reloadPage();
		} catch (e) {
			if (e.code === 1010) {
				dispatch(purgeState());
			}
		}
	};
};

export const updateError = (flag, reason = null) => {
	return async (dispatch, getState) => {
		dispatch({
			type: UPDATE_ERROR,
			payload: { flag: Boolean(flag), reason: reason },
		});
	};
};

export const updateErrorMessage = (flag, text = null) => {
	return async (dispatch, getState) => {
		dispatch({
			type: UPDATE_MESSAGE,
			payload: { flag: Boolean(flag), type: 'error', text },
		});
	};
};

export const updateSuccessMessage = (flag, text = null) => {
	return async (dispatch, getState) => {
		dispatch({
			type: UPDATE_MESSAGE,
			payload: { flag: Boolean(flag), type: 'success', text },
		});
	};
};

export const updateMessage = (flag, text = null) => {
	return async (dispatch, getState) => {
		dispatch({
			type: UPDATE_MESSAGE,
			payload: { flag: Boolean(flag), type: 'info', text },
		});
	};
};

export const resetState = () => {
	return async (dispatch, getState) => {
		dispatch({
			type: RESET_STATE,
			payload: {},
		});
	};
};

export const setBaseUrlDependingOnUserTypes = (userTypes) => {
	if (checkLabSeller(userTypes)) {
		setBaseUrl(LABS_API_HOST);
	} else {
		setBaseUrl(PROCUREMENT_API_HOST);
	}
};
